<script>
export default {
  props: {
    text: String
  }
}
</script>
